import { useNuxtApp, useRuntimeConfig, defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { isEmpty } from 'lodash-es';
import type { RedirectsMap } from '~~/types/globals';

// Nuxt Middleware Handler
export default defineNuxtRouteMiddleware(async (to, from) => {
  // Do nothing if path starts with /api
  if (to.path.startsWith('/api') || to.path === '/') return;

  if (to?.path.includes('//')) {
    return navigateTo('/', { redirectCode: 301 });
  }

  // On CSR we save the redirects, on SSR we pull them everytime
  const { $redirects, provide } = useNuxtApp();
  const config = useRuntimeConfig();

  // On CSR we have to load the redirects and provide them!
  let redirects: RedirectsMap | undefined = $redirects as RedirectsMap;
  if (!$redirects) {
    try {
      const host =
        import.meta.client && config.public.cloudFront.redirectsEnabled && config.app.cdnURL
          ? config.app.cdnURL
          : '';

      redirects = await $fetch(`${host}/api/redirects`);
      provide('redirects', redirects);
    } catch (e) {
      console.error(e);
    }
  }

  if (!redirects) return;

  const redirectForPath = redirects[to.path];

  if (redirectForPath) {
    // Redirect to new url

    let queryString = '';
    if (!isEmpty(to.query) && !redirectForPath.to.includes('?')) {
      const params = new URLSearchParams(to.query as Record<string, string>);
      queryString = `?${params.toString()}`;
    }

    return navigateTo(redirectForPath.to + queryString, {
      redirectCode: redirectForPath.isPermanent ? 301 : 302,
      external: true,
    });
  }
});
